module.exports = __webpack_public_path__ + "static/media/primer_semestre.677f246b.png";